import React from 'react';
import Select from 'react-select';

const SingleSelectWithoutState = (props) => {
  return (
    <>
      {props.showLabelsExplicitely && (
        <>
          <p style={{ marginBottom: 0, marginTop: 20 }}><strong>{props.label}</strong></p>
        </>
      )}
      <Select
        className='react-select'
        classNamePrefix='react-select'
        placeholder={props.placeholder || 'Auswählen...'}
        name={props.name}
        value={props.multi ? props.value : props.options.find(o => o.value === props.value)}
        onChange={selectedOption => { props.setValue(props.multi ? selectedOption ? selectedOption.map(so => so.value) : [] : selectedOption.value); }}
        options={props.options}
        isMulti={props.multi}
        styles={props.customStyles || {
          control: (base, state) => ({
            ...base,
            backgroundColor: 'white'
          })
        }}
      />
    </>
  );
};

export default SingleSelectWithoutState;
